/* eslint-disable */
export default {
  unmute: '取消静音',
  mute: '静音',
  keypad: '拨号键盘',
  hold: '保持',
  onHold: '暂候',
  park: '寄存',
  stopRecord: '停止',
  record: '录制',
  add: '添加',
  transfer: '转接',
  flip: '切换',
  more: '呼叫操作',
  mergeToConference: '合并',
  end: '结束',
  completeTransfer: '完成\n转接',
} as const;

// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"park"@#@ @source: @#@"Park"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"more"@#@ @source: @#@"Call Actions"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete\nTransfer"@#@
